let isMathjaxConfig = false;//用于标识是否配置
const initMathjaxConfig = () => {
  if (!window.MathJax) {
    return;
  }
  // window.MathJax.Hub.Config({
  //   showProcessingMessages: false, //关闭js加载过程信息
  //   messageStyle: "none", //不显示信息
  //   // jax: ["input/TeX", "output/HTML-CSS"],
  //   jax: ["input/TeX", "output/SVG"],
  //   tex2jax: {
  //     inlineMath: [["$", "$"], ["\\(", "\\)"]], //行内公式选择符
  //     displayMath: [["$$", "$$"], ["\\[", "\\]"]], //段内公式选择符
  //     skipTags: ["script", "noscript", "style", "textarea", "pre"] //避开某些标签
  //   },
  //   "HTML-CSS": {
  //     availableFonts: ["STIX", "TeX"], //可选字体
  //     showMathMenu: false //关闭右击菜单显示
  //   }
  // });

  window.MathJax = {

    jax: ["input/TeX", "output/SVG"],
    // jax: ["input/SVG", "output/TeX"],

    extensions: ["tex2jax.js", "MathMenu.js", "MathZoom.js"],

    showMathMenu: false,

    showProcessingMessages: false,

    messageStyle: "none",

    SVG: {

      useGlobalCache: false

    },

    TeX: {

      extensions: ["AMSmath.js", "AMSsymbols.js", "autoload-all.js"]

    },

//     AuthorInit: function() {
//
//       MathJax.Hub.Register.StartupHook("End", function() {
//
//         var mj2img = function(texstring, callback) {
//
//           var input = texstring;
//           var wrapper = document.createElement("div");
//
//           wrapper.innerHTML = input;
//
//           var output = { svg: "", img: ""};
//
//           MathJax.Hub.Queue(["Typeset", MathJax.Hub, wrapper]);
//
//           MathJax.Hub.Queue(function() {
//
//             var mjOut = wrapper.getElementsByTagName("svg")[0];
//
//             mjOut.setAttribute("xmlns", "http://www.w3.org/2000/svg");
//
//             // thanks, https://spin.atomicobject.com/2014/01/21/convert-svg-to-png/
//             output.svg = mjOut.outerHTML;
//
//             var image = new Image();
//
//             image.src = 'data:image/svg+xml;base64,' + window.btoa(unescape(encodeURIComponent(output.svg)));
//
//             image.onload = function() {
//
//               var canvas = document.createElement('canvas');
//
//               canvas.width = image.width;
//
//               canvas.height = image.height;
//
//               var context = canvas.getContext('2d');
//
//               context.drawImage(image, 0, 0);
//
//               output.img = canvas.toDataURL('image/png');
//
//               callback(output);
//
//             };
//
//           });
//
//         }
// // \[f: X \to Y\]
//         mj2img("$$\\frac{b}{a}$$", function(output){
//
//           // document.getElementById("target").innerText = output.img + '\n' + output.svg;
//
//         });
//
//       });
//
//     }

  };

  (function(d, script) {

    script = d.createElement('script');

    script.type = 'text/javascript';

    script.async = true;

    script.onload = function() {

      // remote script has loaded

    };

    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.0/MathJax.js';

    d.getElementsByTagName('head')[0].appendChild(script);

  }(document));

  isMathjaxConfig = true; //配置完成，改为true
};
const MathQueue = function (elementId) {
  if (!window.MathJax) {
    return;
  }

  window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub, document.getElementById(elementId)]);//这里可以用原生的js调用name,class,id。
};
export default {
  isMathjaxConfig,
  initMathjaxConfig,
  MathQueue,
}





//////////////////
// WEBPACK FOOTER
// ./static/js/wangEditor/globalVariable.js
// module id = null
// module chunks = 